var isType = require('./isType');

module.exports = function isInterface(x) {
  return isType(x) && ( x.meta.kind === 'interface' );
};


//////////////////
// WEBPACK FOOTER
// ./~/tcomb/lib/isInterface.js
// module id = 749
// module chunks = 114276838955818